import { acceptHMRUpdate, defineStore } from 'pinia';

export const useCommercialisationStore = defineStore('commercialisation', {
  state: () => ({
    locationList: null, // Documento con la lista de ubicaciones de articulos (Entidad ERP ListaDeUbicaciones)
    pickingList: null, // Documento con la lista de selección de articulos para (Entidad ERP ListaDeUbicacionesParaRecoleccion)
    locationSelected: null, // Ubicacion seleccionada.
    locationsArticlesSelected: null, // Lista de articulos de una ubicacion seleccionada.
    ResetFrmLocation: false, // Vuelve a hacer las llmadas para actulizar los dastos
    ResetFrmLocationSales: false, // Vuelve a hacer las llmadas para actulizar los dastos
    filterText: '', // Texto de filtro para la lista de articulos.
  }),

  persist: true,
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useCommercialisationStore, import.meta.webpackHot));
}
